export type ChatTimeoutClientStage = 'message_id_received' | 'output_done_received';

export function createChatTimeoutStageTracker() {
  let stage: ChatTimeoutClientStage = 'message_id_received';

  return {
    reset() {
      stage = 'message_id_received';
    },
    set(nextStage: ChatTimeoutClientStage) {
      stage = nextStage;
    },
    get() {
      return stage;
    },
  };
}
